// MCP descriptor extension point: a remote MCP connector the customer wants registered.
//
// Shape-aligned with `OpenCodeConfigMcpSchema` in ../contracts/me.ts (the wire contract
// the desktop consumes), with one deliberate difference: the config declares no `id`.
// Ids are server-assigned UUIDs, so the natural key here is the NAME — that is what
// `admin apply` matches on when it decides between create and update.
import { z } from 'zod';
export const McpDescriptorSchema = z.strictObject({
    /** Registered name — the natural key for apply. */
    name: z.string().min(1),
    /**
     * Remote MCP endpoint. The protocol is constrained to http/https on purpose: a bare
     * `host:port` string parses as a valid URL with an opaque scheme, and would only fail
     * later, at connection time.
     */
    url: z.url({ protocol: /^https?$/ }),
});
//# sourceMappingURL=mcp-descriptor.js.map